<template>
  <div id="Resource">
    <!--Header-->
    <div v-if="$route.meta.type !== 'app_setting'"
         class="sub-header mb-4 bg-white d-flex align-items-center justify-content-between">
      <h1 class="title title-breadcrumbs font-weight-bold mb-0">
        {{$t($route.meta.title)}}
      </h1>
      <!-- Page title actions -->
      <Breadcrumb/>
    </div>
    <slot>
      <router-view v-if="true"
                   class="main-wrapper"/>
    </slot>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'

export default {
  name: 'Resource',

  components: {
    Breadcrumb
  }
}
</script>

<style lang="scss" scoped>
  .sub-header {
    height: 50px;
    padding: 0 1.25rem;
    border: 1px solid #DDDDDD;
    @media (max-width: 1100px) {
      padding-left: 2.5rem;
    }
    @media (max-width: 1023px) {
      padding-left: 1.25rem;
    }
    @media (max-width: 1023px) {
      padding-left: 1.25rem;
    }

    .title {
      font-size: 1rem;
      line-height: 1;
      @media (max-width: 1023px) {
        display: none;
      }
    }
  }
  .title-breadcrumbs{
    color: #FAA831;
  }
</style>



// WEBPACK FOOTER //
// src/components/Resource.vue